$(function() {
  $('tr#employer_identifier_row').on('click',function(){
    //unbold other row
    $('tr#employer_identifier_row').css('font-weight','');
    //bold selected row
    $(this).css('font-weight','bold');
  });
});
